import {TransportEntity,} from "@ots-frontend/ots-data";
import {useCallback} from "react";
import {useNavigate} from "react-router-dom";
import {TransportAction} from "./TransportActionMenu";
import {useTransportMutation} from "../../../hooks/useTransportMutation";
import {useDownloadTransportPdf} from "../../../hooks/useDownloadTransportPdf";
import {useApp} from "../../../providers/RegionProvider/RegionProvider";

export type UseTransportActionProps = {}

export type UseTransportActionResult = {
  onTransportActionClick: (transport: TransportEntity, action: TransportAction) => void;
}

export const useTransportAction = (props: UseTransportActionProps = {}): UseTransportActionResult => {
  const {} = props

  const {baseQueryApi} = useApp()
  const navigate = useNavigate();

  const {
    deleteTransport,
  } = useTransportMutation()

  const {
    downloadTransportPdf
  } = useDownloadTransportPdf({baseQueryApi})

  const _onTransportActionClick = useCallback((transport: TransportEntity, action: TransportAction) => {
    if (action === "EDIT") {
      navigate(`/transports/form`, {state: {id: transport.id, database: transport.dbName}})
    } else if (action === "DELETE") {
      deleteTransport(transport.id, undefined)
    } else if (action === "DOWNLOAD") {
      downloadTransportPdf(transport, undefined)
    }
  }, [navigate, deleteTransport, downloadTransportPdf])

  return {
    onTransportActionClick: _onTransportActionClick
  }
}
